import { inherits as _inherits, createClass as _createClass, objectWithoutProperties as _objectWithoutProperties, defineProperty as _defineProperty, classCallCheck as _classCallCheck, callSuper as _callSuper } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import { FieldGroup } from '../FieldGroup.js';
var _excluded = ["name"];

var RegistrationFormField = /*#__PURE__*/function (_React$Component) {
  function RegistrationFormField(props) {
    var _this;

    _classCallCheck(this, RegistrationFormField);

    _this = _callSuper(this, RegistrationFormField, [props]);
    _this.renderChildren = _this.renderChildren.bind(_this);
    return _this;
  }

  _inherits(RegistrationFormField, _React$Component);

  return _createClass(RegistrationFormField, [{
    key: "renderChildren",
    value: function renderChildren() {
      if (this.props.children) {
        var child = React.Children.only(this.props.children);
        return /*#__PURE__*/React.cloneElement(child, {
          name: this.props.name,
          fieldName: this.props.fieldName,
          disabled: !this.props.editable,
          errorMessage: this.props.errorMessage ? this.props.errorMessage.message : null
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      // don't want to pass name through, FieldGroup thinks that's to be pre-pended on all nested controls
      var _this$props = this.props;
      _this$props.name;

      var newProps = _objectWithoutProperties(_this$props, _excluded); // eslint-disable-line no-unused-vars


      if (this.props.available) {
        return /*#__PURE__*/React.createElement(FieldGroup, newProps, this.renderChildren());
      } else {
        return null;
      }
    }
  }]);
}(React.Component);

_defineProperty(RegistrationFormField, "propTypes", {
  children: PropTypes.any,
  available: PropTypes.bool.isRequired,
  name: PropTypes.string.isRequired,
  errorMessage: PropTypes.object,
  fieldName: PropTypes.string,
  editable: PropTypes.bool
});

RegistrationFormField.displayName = "RegistrationFormField";
export { RegistrationFormField };